"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHasCustomValue = exports.findOptionForValue = exports.getOptionValue = exports.getOptionLabel = exports.formatOptionLabel = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("../../utils");
exports.formatOptionLabel = (option) => {
    try {
        return utils_1.humanize(utils_1.removeFieldMappingTag(option));
    }
    catch (e) {
        throw new Error(`Failed to format option label for ${option}`);
    }
};
const isKeyValueOption = (option) => lodash_1.has(option, 'key') && lodash_1.has(option, 'value');
exports.getOptionLabel = (option) => {
    if (lodash_1.has(option, 'label')) {
        return lodash_1.get(option, 'label');
    }
    if (lodash_1.isString(option)) {
        return exports.formatOptionLabel(option);
    }
    if (lodash_1.isNumber(option) || lodash_1.isBoolean(option)) {
        return lodash_1.toString(option);
    }
    if (isKeyValueOption(option)) {
        return lodash_1.get(option, 'value');
    }
    const isObjectOfUnknownSchema = lodash_1.isObject(option);
    if (isObjectOfUnknownSchema) {
        return lodash_1.flatten(lodash_1.toPairs(option)).map(utils_1.humanize).join(' ');
    }
    return '';
};
exports.getOptionValue = (option) => {
    if (isKeyValueOption(option)) {
        return lodash_1.get(option, 'key');
    }
    if (lodash_1.has(option, 'value')) {
        return lodash_1.get(option, 'value');
    }
    return option;
};
const findOption = ({ options, value, }) => lodash_1.find(options, (option) => exports.getOptionValue(option) === exports.getOptionValue(value));
exports.findOptionForValue = ({ labelsCache, options, value, }) => findOption({ options, value }) ||
    findOption({ options: labelsCache, value }) ||
    value;
exports.getHasCustomValue = ({ items, labelsCache, value, }) => {
    if (!value) {
        return false;
    }
    const optionValues = items.map(exports.getOptionValue);
    const labelCacheValues = labelsCache.map(exports.getOptionValue);
    return !optionValues.includes(value) && !labelCacheValues.includes(value);
};
